import { Component, Vue } from 'vue-property-decorator';
import { isEmpty } from 'lodash';

@Component
export default class IsAuthorizedMixin extends Vue {
  get user() {
    return this.$store.state.user || {};
  }

  get isAuthorized(): boolean {
    return !isEmpty(this.user.profile);
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isAuthorized.ts